import Vec2 from 'vec2';
function lerp(a,b,t){
    return a*(1-t) + b*t;
}
export default class particle{
    constructor(args){
        this.pos = new Vec2();
        this.pres = args.pres
        this.iWidth = args.iWidth;
        this.iHeight = args.iHeight;
        
        this.pos.x = args.x||0;
        this.pos.y = args.y||0;
        this.velocity = -0.1 - Math.random()/4
        this.slowVelocity = -0.02 - Math.random()/10
        this.vel = new Vec2(0,this.velocity);
        this.target = this.velocity;

        this.friction = 0.9;
        this.phase = Math.random() * 2 * Math.PI
    }

    update(image,time, logo,sideScale,speedScale){
        this.nPosX = Math.floor( 
            this.pres.w*(this.pos.x + 3*this.iWidth/2)/this.iWidth 
        )  % this.pres.w
        this.nPosY = Math.floor( 
            this.pres.h*(this.pos.y + 3*this.iHeight/2)/this.iHeight 
        ) % this.pres.h
         //console.log(image,'im',this.nPosX,this.nPosY);
         //console.log(this.nPosX,this.nPosY);
        let img = image[this.nPosX][this.pres.h - 1 -this.nPosY] 
    //     if (Math.random()<0.001){
    //        console.log(img)
    //    }
        img = 1 - img
        this.target = -0.1-img
        // this.vel.y += 0.6*(this.target - this.vel.y)
        // this.vel.y = lerp(this.slowGravity,this.gravity,img);

        this.vel.x = sideScale*Math.sin(time + this.phase) * (.1 - img * .075)*(1-logo)
        this.vel.y = speedScale*lerp(this.slowVelocity, this.velocity, img * (1-logo));
        // this.vel.x = Math.sin(time/10)*img;
        // this.vel.y = -0.5;
        // console.log(this.vel.y);
        this.pos = this.pos.add(this.vel, true);
        if(this.pos.y<-this.iHeight/2){
            this.pos.y = this.iHeight/2;
            this.pos.x = (Math.random() - 0.5)*this.iWidth;
        }
        // this.pos.x = Math.min(this.pos.x, 200)
    }
}